import { filterTypes } from './constants';

export const calculateFilterDetune = (ratio) => ratio * 9 * 1200;
export const calculateFilterGain = (ratio) => ratio * 18;
const bwMin = 0.1;
const bwMax = 5;
const calculateFilterBandWidth = (ratio) =>
   bwMin * (bwMax / bwMin) ** (1 - ratio);

const resMin = 0.1;
const resMax = 18;
const calculateFilterResonance = (ratio) =>
   resMin + (resMax - resMin) * (1 - ratio);

export const calculateFilterQ = (ratio, filterType) => {
   if (
      filterType === filterTypes.highpass ||
      filterType === filterTypes.lowpass
   ) {
      return calculateFilterResonance(ratio);
   }
   return calculateFilterBandWidth(ratio);
};
